// Cloudinary URLs for skill badges
import { IMAGES } from '../constants/cloudinaryImages';

const c = IMAGES.skills.c;
const cpp = IMAGES.skills.cpp;
const anaconda = IMAGES.skills.anaconda;
const js = IMAGES.skills.javascript;
const matplot = IMAGES.skills.matplotlib;
const mongoDb = IMAGES.skills.mongodb;
const node = IMAGES.skills.nodejs;
const react = IMAGES.skills.react;
const redux = IMAGES.skills.redux;
const sql = IMAGES.skills.mysql;
const git = IMAGES.skills.git;
const github = IMAGES.skills.github;
const panda = IMAGES.skills.pandas;
const numpy = IMAGES.skills.numpy;
const scikit = IMAGES.skills.scikitlearn;
const python = IMAGES.skills.python;
const next = IMAGES.skills.nextjs;
const npm = IMAGES.skills.npm;
const firebase = IMAGES.skills.firebase;
const tensor = IMAGES.skills.tensorflow;
const selenium = IMAGES.skills.selenium;
const tailwind = IMAGES.skills.tailwindcss;
const css = IMAGES.skills.css3;
const mypic = IMAGES.skills.file;

export {
    c, cpp, anaconda, panda, mongoDb, mypic, tailwind, css, python, next, scikit, selenium, tensor, npm, node,
    firebase, numpy, react, redux, sql, git, github, matplot, js
};
